// 案 B の切り替え（PM の DB を FLA の Supabase へ）の前のログイン情報を、新しい画面の起動時に消す。
//
// Supabase のログイン情報は localStorage の sb-<プロジェクト>-auth-token に入る。切り替えの後の画面は
// FLA の Supabase のキーを見るため、切り替え前のログイン情報は使われず、自動でログイン画面になる。
// 古いキーはそのまま残るだけなので消し、ログイン画面に「切り替えのためログアウトした」ことを案内する
// （何も言わずにログイン画面になると、利用者は何が起きたか分からず、PM の古いメールアドレスで試しうる）。
// 切り替え前の画面を開いたままの利用者は、api/_projectSwitch.js で読み込み直させてからここに来る。

export const SWITCHED_NOTICE = 'システムの切り替えのため、ログアウトしました。Food-Label Assist と同じメールアドレスでログインしてください。';

const AUTH_KEY = /^sb-([a-z0-9-]+)-auth-token$/;

// supabase-js の既定のキー名と同じ（sb-<ホスト名の最初の部分>-auth-token）
export function currentProjectRef(supabaseUrl) {
  try {
    return new URL(supabaseUrl).hostname.split('.')[0] || null;
  } catch (_) {
    return null;
  }
}

// 今の Supabase 以外のログイン情報を消し、消したものがあれば true。
// 今の Supabase が分からないとき（環境変数の設定漏れ等）は何も消さない
export function clearStaleSessions(storage, supabaseUrl) {
  const ref = currentProjectRef(supabaseUrl);
  if (!ref || !storage) return false;
  let removed = false;
  try {
    const keys = [];
    for (let i = 0; i < storage.length; i++) keys.push(storage.key(i));
    for (const key of keys) {
      const m = typeof key === 'string' ? key.match(AUTH_KEY) : null;
      if (m && m[1] !== ref) {
        storage.removeItem(key);
        removed = true;
      }
    }
  } catch (_) {
    // localStorage が使えない（プライベートブラウズ等）ときは何もしない
  }
  return removed;
}
